import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`${prefix}.Equipment.Balance`);
  const deflectionGauge1 = wrap(`${prefix}.Equipment.DisplacementGauge1`);
  const deflectionGauge2 = wrap(`${prefix}.Equipment.DisplacementGauge2`);
  const deflectionGauge3 = wrap(`${prefix}.Equipment.DisplacementGauge3`);
  const loadCell = wrap(`${prefix}.Equipment.LoadCell`);
  return {
    [`${prefix}.Preparation.AdditionalEquipmentMass`]: balance,
    [`${prefix}.Equipment.Plate1.Mass`]: balance,
    [`${prefix}.Equipment.Plate2.Mass`]: balance,
    [`${prefix}.Equipment.CylinderJackMass`]: balance,
    [`${prefix}.LoadIncrements.Readings.GaugeReading1`]: deflectionGauge1,
    [`${prefix}.LoadIncrements.Readings.GaugeReading2`]: deflectionGauge2,
    [`${prefix}.LoadIncrements.Readings.GaugeReading3`]: deflectionGauge3,
    [`${prefix}.InitialSeatingReading.GaugeReading1`]: deflectionGauge1,
    [`${prefix}.InitialSeatingReading.GaugeReading2`]: deflectionGauge2,
    [`${prefix}.InitialSeatingReading.GaugeReading3`]: deflectionGauge3,
    [`${prefix}.LoadIncrements.IncrementLoadInDivisions`]: loadCell,
  };
};

export default getMeasuredUsingConfig;
